import Component from './component'
import {connect} from 'react-redux'
import {editarCorretor, removerPessoaComoCorretor} from '../../../../actions/corretores'
import { showSnack } from 'react-redux-snackbar';

const dispatchTo = (dispatch) =>({
    salvar : (id, obj) => dispatch(editarCorretor(id, obj)),
    feedback : (message) => dispatch(showSnack(Date.now(), {
        label : message,
        timeout : 5000,
        button : {label : 'Beleza'}
    })),
    deletar : (id) => dispatch(removerPessoaComoCorretor(id))
})

export default connect(null, dispatchTo)(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/corretores/corretor/container.js